/* eslint-disable react/jsx-no-useless-fragment */

import React, { useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { t } from 'ttag';
import useSWR from 'swr';

import { mergeClasses } from '@utils';

import ReturnIcon from './QuickHelp/icons/ReturnIcon';

const WITHDRAWAL_URL = '/right-of-withdrawal/';

const fetcher = url => fetch(url).then(r => r.json());

export default function Categories() {
  const history = useHistory();
  const { category } = useParams();

  const { data: categoriesData, isLoading: isLoadingCategories } = useSWR(
    '/api/faq/categories/',
    fetcher
  );

  const isWithdrawalEnabled = Boolean(window?.config?.withdrawal_enabled);

  const handleHistoryPush = useCallback(
    (event, url) => {
      event.preventDefault();
      history.push(url);
    },
    [history]
  );

  if (isLoadingCategories)
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className="h-12 w-12 animate-spin fill-black"
      >
        <path d="M12 3C16.9706 3 21 7.02944 21 12H19C19 8.13401 15.866 5 12 5V3Z" />
      </svg>
    );

  return (
    <ul className="m-0 space-y-4 p-0">
      {isWithdrawalEnabled && (
        <li className="list-none">
          <a
            href={WITHDRAWAL_URL}
            className="box-border block flex items-center justify-between rounded-lg border border-solid border-transparent bg-white p-4 text-sm font-bold text-black no-underline"
          >
            <span className="flex items-center gap-4">
              <ReturnIcon className="h-8 w-8" />
              {t`Withdraw from the contract here`}
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="h-4 w-4"
            >
              <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z" />
            </svg>
          </a>
        </li>
      )}
      {categoriesData?.data?.map?.(({ id, attributes }) => {
        const { icon, title, url_name: categorySlug } = attributes || {};
        const isMatch = category === categorySlug;

        return (
          <li className="list-none">
            <a
              key={id}
              href={`/faq/${categorySlug}/`}
              onClick={event => handleHistoryPush(event, `/${categorySlug}/`)}
              className={mergeClasses(
                'box-border block flex items-center justify-between rounded-lg bg-white p-4 text-sm font-bold text-black no-underline',
                {
                  'border border-solid border-black': isMatch,
                  'border border-solid border-transparent': !isMatch
                }
              )}
            >
              <span className="flex items-center gap-4">
                {icon && (
                  <img
                    src={icon}
                    alt={title}
                    className="h-8 w-8"
                    style={{ filter: 'brightness(0) saturate(100%)' }}
                  />
                )}
                {title}
              </span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className="h-4 w-4"
              >
                <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z" />
              </svg>
            </a>
          </li>
        );
      })}
    </ul>
  );
}
